<template>
  <div>
    <ais-current-refinements v-slot="{ items, createURL }">

        <ul class="ais-CurrentRefinements-list">
          <li
            v-for="item in items"
            :key="item.attribute"
            class="ais-CurrentRefinements-item flex flex-wrap"
          >
            <CurrentRefinementLabel
              v-for="refinement in item.refinements"
              :key="[
                refinement.attribute,
                refinement.type,
                refinement.value,
                refinement.operator
              ].join(':')"
              :refinement="refinement"
              :create-url="createURL"
              class="ais-CurrentRefinements-category
                h-7 py-0.5 px-2 mr-2 mb-1
              "
              @refine="item.refine($event)"
            />
          </li>
        </ul>


    </ais-current-refinements>
    <ais-hierarchical-menu
      v-if="isOnSearchPage || isOnInternalCmsPage"
      v-slot="{ items, refine }"
      class="mt-8"
      :attributes="CATEGORIES_ATTRIBUTES"
     :sort-by="getCustomCategoryTreeOrder">

        <CustomHierarchicalMenuList
          :items="items"
          :refine="refine"
        />


    </ais-hierarchical-menu>
  </div>
</template>

<script lang="ts">

import { AisCurrentRefinements, AisHierarchicalMenu } from 'vue-instantsearch/vue3/es';

import { CATEGORIES_ATTRIBUTES } from '~~/constants/typesense';
import { getCustomCategoryTreeOrder } from '~~/helpers/typesense/getCustomCategoryTreeOrder';

export default defineComponent({
  name: 'CustomCurrentRefinements',
  components: {

    AisCurrentRefinements,

    AisHierarchicalMenu,
  },
  setup () {

    const { isOnSearchPage, isOnInternalCmsPage } = useIsPage();

    return {
      CATEGORIES_ATTRIBUTES,
      isOnSearchPage,
      isOnInternalCmsPage,
      getCustomCategoryTreeOrder,
    };

  },
});

</script>